import { toHttps } from './secureUrl';

function isHttpOrHttpsUrl(urlString: string): boolean {
  try {
    const url = new URL(urlString);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

export function toProxiedImageUrl(url: string | null | undefined, useProxy = true): string | undefined {
  const httpsUrl = toHttps(url ?? undefined);
  if (!httpsUrl) return undefined;

  if (httpsUrl.startsWith('/') || httpsUrl.startsWith('data:') || httpsUrl.startsWith('blob:')) {
    return httpsUrl;
  }

  if (!isHttpOrHttpsUrl(httpsUrl)) return httpsUrl;

  if (!useProxy) return httpsUrl;

  return `/api/proxy-image?url=${encodeURIComponent(httpsUrl)}`;
}

export function toDirectImageUrl(url: string | null | undefined): string | undefined {
  return toProxiedImageUrl(url, false);
}

export function isIconUrl(value: string | null | undefined): boolean {
  if (!value) return false;
  return value.startsWith('http://') || value.startsWith('https://') || value.startsWith('/') || value.startsWith('data:') || value.startsWith('blob:');
}

